import React, { createContext, useContext, useState } from 'react';

const translations = {
  vi: {
    // Language selector
    'lang.vi': 'Tiếng Việt',
    'lang.en': 'English',
    // Admin dashboard
    'admin.title': 'Bảng điều khiển quản trị',
    'admin.overview': 'Tổng quan',
    'admin.cache': 'Bộ nhớ cache',
    'admin.suggestions': 'Gợi ý',
    'admin.llm': 'LLM',
    'admin.backtest': 'Backtest',
    'admin.data_quality': 'Chất lượng dữ liệu',
    'admin.symbols': 'Mã chứng khoán',
    'admin.historical': 'Dữ liệu lịch sử',
    'admin.news': 'Tin tức',
    'admin.users': 'Người dùng',
    'admin.logs': 'Nhật ký',
    'admin.logout': 'Đăng xuất',
    'admin.llm_connected': 'LLM: Đã kết nối',
    'admin.llm_not_configured': 'LLM: Chưa cấu hình',
    'admin.db_connected': 'DB: Đã kết nối',
    'admin.db_not_configured': 'DB: Chưa cấu hình',
    'admin.total_stocks': 'Tổng số cổ phiếu',
    'admin.all_markets': 'Trên tất cả thị trường',
    'admin.cached_prices': 'Giá lịch sử',
    'admin.data_points': 'Số điểm dữ liệu đã lưu',
    'admin.suggestions_24h': 'Gợi ý (24h)',
    'admin.created_today': 'Được tạo hôm nay',
    'admin.backtests_24h': 'Backtest (24h)',
    'admin.run_today': 'Chạy hôm nay',
    'admin.refresh': 'Làm mới',
    'admin.market': 'Thị trường',
    'admin.healthy': 'Khỏe mạnh',
    'admin.stale': 'Cũ',
    'admin.last_price': 'Ngày giá cuối',
    'admin.days_since': 'Số ngày',
    'admin.indicators': 'Chỉ báo',
    'admin.predictions': 'Dự báo',
    'admin.status': 'Trạng thái',
    'admin.yes': 'Có',
    'admin.no': 'Không',
    'admin.trading_analysis': 'Phân tích gợi ý giao dịch',
    'admin.symbol_count': 'Số lượng mã',
    'admin.trend_bullish': 'Xu hướng tăng',
    'admin.trend_bearish': 'Xu hướng giảm',
    'admin.total': 'Tổng',
    'admin.run_backtest': 'Chạy backtest',
    'admin.add': 'Thêm',
    'admin.edit': 'Sửa',
    'admin.delete': 'Xóa',
    'admin.save': 'Lưu',
    'admin.cancel': 'Hủy',
    'admin.search': 'Tìm kiếm',
    'admin.no_data': 'Không có dữ liệu',
    'admin.loading': 'Đang tải...',
    // Stock metrics
    'metric.marketcap': 'Vốn hóa thị trường',
    'metric.pe': 'P/E',
    'metric.eps': 'EPS',
    'metric.avg_volume': 'Khối lượng TB',
    'metric.52w_high': 'Cao 52W',
    'metric.52w_low': 'Thấp 52W',
    'follow': 'Theo dõi',
    'following': 'Đang theo dõi',
    'analyze.button': 'Phân tích bằng AI',
    'analyze.rerun': 'Chạy lại',
    'ai.title': 'Phân tích AI',
    'ai.insights': 'Nhận định',
    'ai.predictions': 'Dự báo',
    'ai.model_details': 'Chi tiết mô hình',
    'ai.model_note': 'Được huấn luyện cục bộ — dự báo mang tính tham khảo.' ,
    'ai.model_label': 'Mô hình',
    'ai.model_name': 'Random Forest',
    'ai.translated_badge': 'Đã dịch',
    'ai.error_hint': 'Vui lòng thử lại hoặc kiểm tra kết nối.',
    'news.title': 'Tin tức / Bài báo',
    'daytrade.run': 'Chạy backtest giao dịch trong ngày',
    'daytrade.summary': 'Tóm tắt backtest',
    'daytrade.save': 'Lưu kết quả',
    'daytrade.saved_runs': 'Kết quả đã lưu',
    'daytrade.refresh': 'Làm mới',
    'daytrade.no_runs': 'Chưa có kết quả lưu',
    'daytrade.view': 'Xem',
    'daytrade.final_equity': 'Vốn cuối',
    'daytrade.run_details': 'Chi tiết lệnh',
    'news.no_articles': 'Không có bài viết gần đây',
    'pred.day': '[n] Ngày',
    'btn.vn': 'VN',
    'app.title': 'Market360 Pro',
    'nav.getStarted': 'Bắt đầu',
    'hero.headline': 'Phân tích chứng khoán AI chuyên nghiệp',
    'hero.subtitle': 'Trải nghiệm thông tin thị trường cấp tổ chức với nền tảng giao dịch sử dụng AI. Phân tích thời gian thực, dự báo học máy và phân tích kỹ thuật toàn diện.',
    'waitlist.placeholder': 'Nhập email để được truy cập sớm',
    'waitlist.button': 'Tham gia danh sách chờ',
    'features.title': 'Tính năng mạnh mẽ',
    'features.subtitle': 'Mọi thứ bạn cần để phân tích chứng khoán chuyên nghiệp và ra quyết định giao dịch',
    'feature.ai_predictions': 'Dự báo giá AI',
    'feature.40indicators': 'Hơn 40 chỉ báo kỹ thuật',
    'feature.ai_insights': 'Nhận định thị trường AI',
    'feature.performance': 'Chỉ số hiệu suất',
    'feature.realtime': 'Dữ liệu thời gian thực',
    'feature.interface': 'Giao diện chuyên nghiệp',
    'controls.customSymbolPlaceholder': 'Mã chứng khoán',
    'controls.analyze': 'Phân tích',
    'period.1mo': '1 Tháng',
    'period.3mo': '3 Tháng',
    'period.6mo': '6 Tháng',
    'period.1y': '1 Năm',
    'period.2y': '2 Năm',
    'period.5y': '5 Năm',
    'tabs.overview': 'Tổng quan',
    'tabs.tech': 'Phân tích kỹ thuật',
    'tabs.ai': 'Dự báo AI',
    'tabs.performance': 'Hiệu suất',
    'tabs.history': 'Dữ liệu lịch sử',
    'overview.realtime': 'Giá',
    'overview.ai_prediction': 'Dự báo AI',
    'overview.ai_insights': 'Nhận định AI',
    'prediction.price_prediction': 'Dự báo giá',
    'prediction.train_model': 'Huấn luyện/Cập nhật mô hình',
    'performance.sharpe': 'Tỷ lệ Sharpe',
    'performance.volatility': 'Độ biến động',
    'performance.max_drawdown': 'Mức giảm tối đa',
    'performance.total_return': 'Tổng lợi nhuận',
    'data.recent': 'Dữ liệu gần đây',
    'data.addSample': 'Thêm dữ liệu mẫu',
    'loading': 'Đang tải...',
    'chart.loading': 'Đang tải biểu đồ...',
    'back': 'Quay lại',
    'detail.recentData': 'Dữ liệu chi tiết',
    'stocklist.title': 'Chứng khoán',
    'stocklist.date': 'Ngày',
    'table.symbol': 'Ký hiệu',
    'table.price': 'Giá',
    'table.timestamp': 'Dấu thời gian',
    'stock.liveFeed': 'Nguồn giá trực tiếp',
    'tabs.1day': '1 NGÀY',
    'tabs.1week': '1 TUẦN',
    'tabs.1month': '1 THÁNG'
    ,
    'strategy.param.ema_short': 'EMA ngắn',
    'strategy.param.ema_long': 'EMA dài',
    'strategy.param.sma_trend': 'SMA xu hướng',
    'strategy.param.stop_loss_pct': 'Stop Loss (%)',
    'strategy.param.take_profit_mult': 'Take Profit x',
    'strategy.param.or_hours': 'Opening Range (giờ)',
    'strategy.param.market_symbol': 'Mã thị trường',
    'strategy.param.entry_start': 'Bắt đầu entry',
    'strategy.param.entry_end': 'Kết thúc entry',
    'strategy.param.risk_per_trade': 'Rủi ro mỗi lệnh',
    'strategy.param.max_trades_per_day': 'Tối đa lệnh/ngày',
    'strategy.tooltip.ema_short': 'EMA ngắn dùng để xác định pullback ngắn hạn. Tăng để làm mịn hơn.',
    'strategy.tooltip.ema_long': 'EMA dài dùng để giữ xu hướng trung bình. Giữ thấp cho phản ứng nhanh hơn.',
    'strategy.tooltip.sma_trend': 'Đường trung bình đơn để xác định xu hướng chính (ví dụ SMA200).',
    'strategy.tooltip.stop_loss_pct': 'Tỷ lệ dừng lỗ theo phần trăm so với giá vào. Giảm để giới hạn rủi ro.',
    'strategy.tooltip.take_profit_mult': 'Bội số mục tiêu so với dừng lỗ (ví dụ 2 = take profit = 2x stop loss).',
    'strategy.tooltip.or_hours': 'Số giờ dùng để tính Opening Range (ví dụ 2 = 2 giờ đầu giao dịch).',
    'strategy.tooltip.market_symbol': 'Mã tham chiếu cho chiến lược cặp hoặc danh mục (ví dụ: đối tác).',
    'strategy.tooltip.entry_start': 'Thời gian bắt đầu cho phép vào lệnh (HH:MM).',
    'strategy.tooltip.entry_end': 'Thời gian kết thúc cho phép vào lệnh (HH:MM).',
    'strategy.tooltip.risk_per_trade': 'Tỷ lệ phần trăm vốn rủi ro cho mỗi lệnh.',
    'strategy.tooltip.max_trades_per_day': 'Giới hạn số lệnh tối đa mỗi ngày.',
    'keymetrics.title': 'Thống kê chính'
    , 'ai.no_insights': 'Không có nhận định'
  },
  en: {
    // Language selector
    'lang.vi': 'Tiếng Việt',
    'lang.en': 'English',
    // Admin dashboard
    'admin.title': 'Admin Dashboard',
    'admin.overview': 'Overview',
    'admin.cache': 'Cache',
    'admin.suggestions': 'Suggestions',
    'admin.llm': 'LLM',
    'admin.backtest': 'Backtest',
    'admin.data_quality': 'Data Quality',
    'admin.symbols': 'Symbols',
    'admin.historical': 'Historical Data',
    'admin.news': 'News',
    'admin.users': 'Users',
    'admin.logs': 'Logs',
    'admin.logout': 'Logout',
    'admin.llm_connected': 'LLM: Connected',
    'admin.llm_not_configured': 'LLM: Not configured',
    'admin.db_connected': 'DB: Connected',
    'admin.db_not_configured': 'DB: Not configured',
    'admin.total_stocks': 'Total stocks',
    'admin.all_markets': 'All markets',
    'admin.cached_prices': 'Historical prices',
    'admin.data_points': 'Data points saved',
    'admin.suggestions_24h': 'Suggestions (24h)',
    'admin.created_today': 'Created today',
    'admin.backtests_24h': 'Backtests (24h)',
    'admin.run_today': 'Run today',
    'admin.refresh': 'Refresh',
    'admin.market': 'Market',
    'admin.healthy': 'Healthy',
    'admin.stale': 'Stale',
    'admin.last_price': 'Last price date',
    'admin.days_since': 'Days since',
    'admin.indicators': 'Indicators',
    'admin.predictions': 'Predictions',
    'admin.status': 'Status',
    'admin.yes': 'Yes',
    'admin.no': 'No',
    'admin.trading_analysis': 'Trading suggestions analysis',
    'admin.symbol_count': 'Symbol count',
    'admin.trend_bullish': 'Bullish trend',
    'admin.trend_bearish': 'Bearish trend',
    'admin.total': 'Total',
    'admin.run_backtest': 'Run backtest',
    'admin.add': 'Add',
    'admin.edit': 'Edit',
    'admin.delete': 'Delete',
    'admin.save': 'Save',
    'admin.cancel': 'Cancel',
    'admin.search': 'Search',
    'admin.no_data': 'No data',
    'admin.loading': 'Loading...',
    // Stock metrics
    'metric.marketcap': 'Market Cap',
    'metric.pe': 'P/E',
    'metric.eps': 'EPS',
    'metric.avg_volume': 'Avg Volume',
    'metric.52w_high': '52W High',
    'metric.52w_low': '52W Low',
    'follow': 'Follow',
    'following': 'Following',
    'analyze.button': 'Analyze with AI',
    'analyze.rerun': 'Re-run',
    'ai.title': 'AI Analysis & Predictions',
    'ai.insights': 'Insights',
    'ai.predictions': 'Predictions',
    'ai.model_details': 'Model Details',
    'ai.model_note': 'Trained locally — predictions are indicative.',
    'ai.model_label': 'Model',
    'ai.model_name': 'Random Forest',
    'ai.translated_badge': 'Translated',
    'news.title': 'News / Articles',
    'daytrade.run': 'Run intraday backtest',
    'daytrade.summary': 'Backtest summary',
    'daytrade.save': 'Save run',
    'daytrade.saved_runs': 'Saved runs',
    'daytrade.refresh': 'Refresh',
    'daytrade.no_runs': 'No saved runs',
    'daytrade.view': 'View',
    'daytrade.final_equity': 'Final equity',
    'daytrade.run_details': 'Run details',
    'news.no_articles': 'No recent articles',
    'pred.day': '[n] Day',
    'btn.vn': 'VN',
    'app.title': 'Market360 Pro',
    'nav.getStarted': 'Get Started',
    'hero.headline': 'Professional AI Stock Analysis',
    'hero.subtitle': 'Experience institutional-grade market intelligence with our advanced AI-powered trading platform. Real-time analysis, machine learning predictions, and comprehensive technical insights.',
    'waitlist.placeholder': 'Enter your email for early access',
    'waitlist.button': 'Join Waitlist',
    'features.title': 'Powerful Features',
    'features.subtitle': 'Everything you need for professional stock analysis and trading decisions',
    'feature.ai_predictions': 'AI Price Predictions',
    'feature.40indicators': '40+ Technical Indicators',
    'feature.ai_insights': 'AI Market Insights',
    'feature.performance': 'Performance Metrics',
    'feature.realtime': 'Real-Time Data',
    'feature.interface': 'Professional Interface',
    'controls.customSymbolPlaceholder': 'Custom symbol',
    'controls.analyze': 'Analyze',
    'period.1mo': '1 Month',
    'period.3mo': '3 Months',
    'period.6mo': '6 Months',
    'period.1y': '1 Year',
    'period.2y': '2 Years',
    'period.5y': '5 Years',
    'tabs.overview': 'Overview',
    'tabs.tech': 'Technical Analysis',
    'tabs.ai': 'AI Predictions',
    'tabs.performance': 'Performance',
    'tabs.history': 'Historical Data',
    'overview.realtime': 'Real-time Price',
    'overview.ai_prediction': 'AI Prediction',
    'overview.ai_insights': 'AI Insights',
    'prediction.price_prediction': 'Price Prediction',
    'prediction.train_model': 'Train/Update Model',
    'performance.sharpe': 'Sharpe Ratio',
    'performance.volatility': 'Volatility',
    'performance.max_drawdown': 'Max Drawdown',
    'performance.total_return': 'Total Return',
    'data.recent': 'Recent Stock Data',
    'data.addSample': 'Add Sample Data',
    'loading': 'Loading...',
    'chart.loading': 'Loading chart...',
    'back': 'Back',
    'detail.recentData': 'Detail / Recent Data',
    'stocklist.title': 'Stocks',
    'stocklist.date': 'Date',
    'table.symbol': 'Symbol',
    'table.price': 'Price',
    'table.timestamp': 'Timestamp',
    'stock.liveFeed': 'Live Price Feed',
    'tabs.1day': '1DAY',
    'tabs.1week': '1WEEK',
    'tabs.1month': '1MONTH'
    ,
    'strategy.param.ema_short': 'EMA short',
    'strategy.param.ema_long': 'EMA long',
    'strategy.param.sma_trend': 'SMA trend',
    'strategy.param.stop_loss_pct': 'Stop Loss (%)',
    'strategy.param.take_profit_mult': 'Take Profit x',
    'strategy.param.or_hours': 'Opening Range (hours)',
    'strategy.param.market_symbol': 'Market Symbol',
    'strategy.param.entry_start': 'Entry Start',
    'strategy.param.entry_end': 'Entry End',
    'strategy.param.risk_per_trade': 'Risk per trade',
    'strategy.param.max_trades_per_day': 'Max trades/day',
    'strategy.tooltip.ema_short': 'Short EMA used to detect short pullbacks. Increase to smooth more.',
    'strategy.tooltip.ema_long': 'Long EMA for medium-term trend. Lower value reacts faster.',
    'strategy.tooltip.sma_trend': 'Simple MA to identify main trend (eg SMA200).',
    'strategy.tooltip.stop_loss_pct': 'Percentage stop loss from entry price. Lower reduces risk.',
    'strategy.tooltip.take_profit_mult': 'Take profit multiplier relative to stop loss (e.g. 2 = TP = 2x SL).',
    'strategy.tooltip.or_hours': 'Number of hours to compute Opening Range (e.g. 2 = first 2 trading hours).',
    'strategy.tooltip.market_symbol': 'Reference symbol for pair strategies or basket (e.g. counterpart).',
    'strategy.tooltip.entry_start': 'Start time for allowed entries (HH:MM).',
    'strategy.tooltip.entry_end': 'End time for allowed entries (HH:MM).',
    'strategy.tooltip.risk_per_trade': 'Percent of portfolio risked per trade.',
    'strategy.tooltip.max_trades_per_day': 'Maximum allowed trades per day.',
    'keymetrics.title': 'Key stats & metrics'
    , 'ai.no_insights': 'No insights available'
  }
};

const LocaleContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState('vi');
  // theme: 'dark' | 'light'
  const [theme, setTheme] = useState(() => {
    try{ return window.localStorage.getItem('market360.theme') || 'dark' }catch(e){ return 'dark' }
  });
  const setThemeAndPersist = (v) => {
    try{ window.localStorage.setItem('market360.theme', v) }catch(e){}
    setTheme(v);
  };
  const t = (key) => {
    return translations[lang] && translations[lang][key] ? translations[lang][key] : (translations['en'][key] || key);
  };
  return (
    <LocaleContext.Provider value={{ lang, setLang, t, theme, setTheme: setThemeAndPersist }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useI18n() {
  return useContext(LocaleContext);
}
